// extracted by mini-css-extract-plugin
export default {"pageContainer":"register_pageContainer__fhNZ3"};